module.exports = __webpack_public_path__ + "media/quakerpapagaj_k.98ad3798.mp3";